<template>
  <div id="app">
    <div class="container app">
      <div class="row app-one">
        <div class="col-sm-4 side">
          <div class="side-one">
            <!-- Heading -->
            <div class="row heading">
              <div class="col-sm-3 col-xs-3 heading-avatar">
                <div class="heading-avatar-icon">
                  <img src="/static/img/bg.webp" />
                </div>
              </div>
              <div class="col-sm-1 col-xs-1 heading-dot pull-right">
                <i class="fa fa-ellipsis-v fa-2x pull-right" aria-hidden="true"></i>
              </div>
              <div class="col-sm-2 col-xs-2 heading-compose pull-right">
                <i class="fa fa-comments fa-2x pull-right" aria-hidden="true"></i>
              </div>
            </div>
            <!-- Heading End -->

            <!-- SearchBox -->
            <div class="row searchBox">
              <div class="col-sm-12 searchBox-inner">
                <div class="form-group has-feedback">
                  <input
                    id="searchText"
                    type="text"
                    class="form-control"
                    name="searchText"
                    placeholder="Search"
                  />
                  <span class="glyphicon glyphicon-search form-control-feedback"></span>
                </div>
              </div>
            </div>

            <!-- Search Box End -->
            <!-- sideBar -->
            <div class="row sideBar">
              <div
                class="row sideBar-body"
                v-bind:class="{'highlight':selected.number == c.number,'bg-red':c.data.help>2, 'newChat' : c.newChat}"
                v-for="(c,index) in conversations"
                v-bind:key="index"
              >
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <i
                      class="fa fa-cart-arrow-down payment-confirmed-i"
                      v-if="c.data.payment_confirmed"
                    ></i>
                    <!-- <img src="/static/img/bg.webp"> -->
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main" @click="getChat(c,index)">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">
                        {{c.data.userName!=null?c.data.userName:"NO NAME"}}
                      </span>
                        <!-- <i
                          class="fa fa-bell hide"
                          style="color:blue"
                          v-bind:class="{'show':c.alert}"
                        ></i> -->
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span
                        class="time-meta pull-right"
                        v-if="c.data.lastupdatedat"
                      >{{new Date(c.data.lastupdatedat*1000).toLocaleString()}}</span>
                    </div>
                    <div
                      class="col-sm-8 col-xs-8"
                      style="font-size: 12px;position: absolute;top: 30px;"
                    >
                      <span class="name-meta" style="color:#959798">{{c.data.lastMessage}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
            <!-- Sidebar End -->
          </div>
          <div class="side-two">
            <!-- Heading -->
            <div class="row newMessage-heading">
              <div class="row newMessage-main">
                <div class="col-sm-2 col-xs-2 newMessage-back">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </div>
                <div class="col-sm-10 col-xs-10 newMessage-title">New Chat</div>
              </div>
            </div>
            <!-- Heading End -->

            <!-- ComposeBox -->
            <div class="row composeBox">
              <div class="col-sm-12 composeBox-inner">
                <div class="form-group has-feedback">
                  <input
                    id="composeText"
                    type="text"
                    class="form-control"
                    name="searchText"
                    placeholder="Search People"
                  />
                  <span class="glyphicon glyphicon-search form-control-feedback"></span>
                </div>
              </div>
            </div>
            <!-- ComposeBox End -->

            <!-- sideBar -->
            <div class="row compose-sideBar">
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row sideBar-body">
                <div class="col-sm-3 col-xs-3 sideBar-avatar">
                  <div class="avatar-icon">
                    <img src="/static/img/bg.webp" />
                  </div>
                </div>
                <div class="col-sm-9 col-xs-9 sideBar-main">
                  <div class="row">
                    <div class="col-sm-8 col-xs-8 sideBar-name">
                      <span class="name-meta">Ankit Jain</span>
                    </div>
                    <div class="col-sm-4 col-xs-4 pull-right sideBar-time">
                      <span class="time-meta pull-right">18:18</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Sidebar End -->
        </div>

        <!-- New Message Sidebar End -->

        <!-- Conversation Start -->
        <div class="col-sm-8 conversation" v-if="selected.number!=null">
          <!-- Heading -->
          <div class="row heading">
            <div class="col-sm-2 col-md-1 col-xs-3 heading-avatar">
              <div class="heading-avatar-icon">
                <img src="/static/img/bg.webp" />
              </div>
            </div>
            <div class="col-sm-8 col-xs-7 heading-name">
              <a class="heading-name-meta">
                {{selected.number}}
              <button class="btn btn-info btn-sm pull-right" @click="closeChat((selected.data.isOpenChat ? false : true),selected.number)">
                {{selected.data.isOpenChat ? 'OFF' : 'ON'}}
              </button>
                <!-- <button
                  class="btn btn-info btn-sm pull-right"
                  @click="updateAutoPilot()"
                >AUTOPILOT {{selected.data.autopilot?" ON":"OFF"}}</button> -->
              </a>
              <span class="heading-online"></span>
            </div>
            <div class="col-sm-1 col-xs-1 heading-dot pull-right">
              <i class="fa fa-ellipsis-v fa-2x pull-right" aria-hidden="true"></i>
            </div>
          </div>
          <!-- Heading End -->

          <!-- Message Box -->
          <div class="row message" id="conversation">
            <div class="row message-previous">
              <div class="col-sm-12 previous">
                <a onclick="previous(this)" id="ankitjain28" name="20">Show Previous Message!</a>
              </div>
            </div>
            <div class="row message-body" v-for="(c,index) in chats" v-bind:key="index">
              <div
                class="col-sm-12 message-main-receiver"
                v-bind:class="{'message-main-receiver':!c.incoming, 'message-main-sender':c.incoming}">
                <!-- <div class v-bind:class="{'receiver':!c.incoming, 'sender':c.incoming}"> -->
                <div class v-bind:class="{'receiver':!c.incoming, 'sender':c.incoming}">
                  <div class="message-text" v-if="c.messageType==='SHOPPING_ORDER'">
                    <b>Item Name </b> : <span>{{JSON.parse(c.message).itemName || ''}} </span><br/>
                    <b>Selling Price </b> : <span> {{JSON.parse(c.message).sellingPrice || ''}} /- </span><br/>
                    <b>MRP </b> : <span> {{JSON.parse(c.message).mrp}} /- </span> <br/>
                    <b>Link </b>: <span> <a :href="JSON.parse(c.message).clickUrl || 'JavaScript:Void(0)'">{{JSON.parse(c.message).clickUrl}} </a> </span><br/><br/>
                    <img :src="JSON.parse(c.message).itemImage" alt height="150" width="100"/>
                  </div>
                  <div class="message-text" v-else>{{c.message}}</div>
                  <span v-if="c.timeInMillis" class="message-time pull-right"> {{new Date(c.timeInMillis*1000).toLocaleTimeString([],{hour12  :true}).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")}} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Message Box End -->

          <!-- Reply Box -->
          <div class="row reply">
            <div class="col-sm-1 col-xs-1 reply-emojis">
              <i class="fa fa-smile-o fa-2x"></i>
            </div>
            <div class="col-sm-9 col-xs-9 reply-main">
              <textarea :disabled="!selected.data.isOpenChat"
                class="form-control"
                rows="1"
                @keydown="checkKey($event)"
                v-model="msg_to_send"
                id="comment"
              ></textarea>
            </div>
            <div class="col-sm-1 col-xs-1 reply-recording">
              <i class="fa fa-microphone fa-2x" aria-hidden="true"></i>
            </div>
            <div v-if="selected.data.isOpenChat" class="col-sm-1 col-xs-1 reply-send" @click="sendMessage()">
              <i class="fa fa-send fa-2x" aria-hidden="true"></i>
            </div>
          </div>
          <!-- Reply Box End -->
        </div>
        <!-- Conversation End -->
      </div>
      <!-- App One End -->
    </div>
  </div>
</template>

<script>
import constants from "./constant.js";
export default {
  name: "app",
  data() {
    return {
      conversations: [],
      chats: [],
      msg_to_send: "",
      selected: {
        number: null
      },
      listener: null,
      ref: null,
      last_updated_at: null,
      page: 0,
      limit: 0,
      showChat : false
    };
  },
  mounted() {
    var _this = this;
    _this.showConversationsList();
  },
  computed: {
    reverseItems() {
      return this.chats.slice().reverse();
    }
  },
  methods: {
    move(a, from, to) {
      a.splice(to, 0, a.splice(from, 1)[0]);
    },
    updateAutoPilot: function() {
      var _this = this;
      var obj = {
        to: this.$data.selected.number,
        flag: !this.$data.selected.data.autopilot
      };
      $.ajax({
        type: "POST",
        url: constants.BASE_URL + "chatscreen/set-auto-pilot",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(obj),
        success: function(data) {
          _this.$data.selected.data.autopilot = !_this.$data.selected.data
            .autopilot;
        }
      });
    },
    checkKey(e){
      if (e.keyCode == 13 && !e.shiftKey) {
        this.sendMessage();
      }
    },
    async sendMessage() {
      if(this.$data.msg_to_send.trim().length>0){
        var _this = this;
        let msgToSend = _this.$data.msg_to_send;
        console.log('msg send',_this.$data.msg_to_send);
        if (_this.$data.msg_to_send) {
          var obj = {
            to: _this.$data.selected.number,
            message: _this.$data.msg_to_send
          };
          let new_data = await _this.database.ref('chat_message_dost/'+obj.to).push()
          let setNewData = await new_data.set({
            "channelName" : _this.$data.selected.number,
            "oppunentId" : "",
            "userId" : "4808fa487cdf5045cc7f867af38ed9c5",
            "timeInMillis" : _this.firebase.database.ServerValue.TIMESTAMP,
            "message" : obj.message,
            "messageType" : "TEXT",
            "mediaUrl" : ""
          })
          console.log('setNewData',setNewData);
          let update_meta_data = await _this.database.ref(`chat_message_dost_meta/${_this.$data.selected.number}`)
            .update({
              "lastMessage" : obj.message,
              "timeInMillis" : _this.firebase.database.ServerValue.TIMESTAMP,
              "isOpenChat" : true
            });
          console.log('update_meta_data',update_meta_data);
          _this.showConversationsList();
          _this.$data.msg_to_send = "";

          _this.database.ref(`chat_status/${_this.$data.selected.number}`).once('value').then(function(snapshot){
            let _d = snapshot.val()
            console.log(_d)
            if(_d){
              let t1= new Date(_d['user']['timeInMillis'])
              let t2 = new Date()
              if ((t2-t2)/1000>60 || true ){
                _this.sendNotification(msgToSend)
              }
            }else{
              _this.sendNotification(msgToSend)
            }


          })
        }
      }

      setTimeout(function(){
        $("#conversation").scrollTop($("#conversation")[0].scrollHeight);
      },200)


    },

    sendNotification(msgToSend){
      var _this = this
      console.log(msgToSend)
      let _msg = {"channelName":"4808fa487cdf5045cc7f867af38ed9c5__"+_this.$data.selected.number,"mediaUrl":"","message":msgToSend,"messageType":"TEXT","oppunentId":_this.$data.selected.number,"senderName":"","timeInMillis":0,"userId":"4808fa487cdf5045cc7f867af38ed9c5"}
      let obj = {"applicationId":149,"dataMap":{"message":JSON.stringify(_msg) ,"subject":"firebase_chat"},"sendToAll":false,"xAuthIds":[_this.$data.selected.number] }
      $.ajax({
        type: "POST",
        url: "https://be.payboard.in/PayBoard/rest/notification/sendLocalizedNotification",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(obj),
        success: function(data) {
          console.log(data)
        }
      });
    },
    getChat: function(obj,index) {
      var _this = this;
      _this.$data.chats = [];
        let temp = JSON.parse(JSON.stringify(obj));
      if(_this.$data.conversations && _this.$data.conversations.length && _this.$data.conversations[index] && _this.$data.conversations[index]['newChat'])
      {
        _this.$data.conversations[index]['newChat'] = false;
      }
      if(_this.$data.selected!=null){
        _this.database.ref(`chat_message_dost/${temp.number}`).off();
      }
      _this.$data.listener = _this.database
        .ref(`chat_message_dost/${temp.number}`)
        .orderByChild("timeInMillis")
        .limitToLast(100)
        .on("child_added", function(data) {
          let respData = data.val();
          console.log('chats',respData)
          respData['incoming'] =  (respData.userId && respData.userId==="4808fa487cdf5045cc7f867af38ed9c5") ? true  :false
          if(respData){
            _this.$data.chats.push(respData);
          }
          setTimeout(function(){
            $("#conversation").scrollTop($("#conversation")[0].scrollHeight);
          },200)
      });
      _this.$data.selected = temp;
      _this.$data.page = 0;

    },

    async closeChat(booleanValue,conversationId){
      await this.database.ref().child(`chat_message_dost_meta/${conversationId}`)
        .update({
          "timeInMillis" : this.firebase.database.ServerValue.TIMESTAMP,
          "isOpenChat" : booleanValue
      });
      console.log('selected',this.$data.selected);
      this.$data.selected.data.isOpenChat = !this.$data.selected.data.isOpenChat;
    },

    showConversationsList(){
      var _this = this;
      _this.$data.conversations = [];
      _this.database
        .ref("chat_message_dost_meta")
        .orderByChild("timeInMillis")
        .limitToLast(100)
        .on("child_added", function(data) {
          var obj = {
            number: data.key,
            data: data.val(),
            incoming : false,
          };
        _this.$data.conversations.unshift(obj);
      });
       _this.database
        .ref("chat_message_dost_meta")
        .orderByChild("timeInMillis")
        .limitToLast(100)
        .on("child_changed", function(data) { 
          if(data && data.val()){
            const temp = data.val();
            const foundUserIndex =_this.$data.conversations.findIndex(function(conversation){
              return conversation.number === data.key
            })
            if(foundUserIndex!=null){
              if(_this.$data.conversations[foundUserIndex]){
                console.log('foundUserIndex data',_this.$data.conversations[foundUserIndex]);
                _this.$data.conversations[foundUserIndex]['newChat'] = true;
                _this.move(_this.$data.conversations,foundUserIndex,0);
              }
            }
          }
      });

    }
  }
};
</script>

<style>
html,
body,
div,
span {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  background: url("/static/img/bg.webp") no-repeat fixed center;
  background-size: cover;
}

.fa-2x {
  font-size: 1.5em !important;
}

.app {
  width: 100% !important;
  top: 0 !important;
  height: 100% !important;

  position: relative;
  overflow: hidden;
  top: 19px;
  height: calc(100% - 38px);
  margin: auto !important;
  padding: 0 !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2);
}

.app-one {
  background-color: #f7f7f7;
  height: 100%;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2);
}

.side {
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
}
.side-one {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  position: relative;
  display: block;
  top: 0;
}

.side-two {
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
  width: 100%;
  z-index: 2;
  position: relative;
  top: -100%;
  left: -100%;
  -webkit-transition: left 0.3s ease;
  transition: left 0.3s ease;
}

.heading {
  padding: 10px 16px 10px 15px;
  margin: 0 !important;
  height: 60px;
  width: 100%;
  background-color: #eee;
  z-index: 1000;
}

.heading-avatar {
  padding: 0 !important;
  cursor: pointer;
}

.heading-avatar-icon img {
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

.heading-name {
  padding: 0 !important;
  cursor: pointer;
}

.heading-name-meta {
  font-weight: 700;
  font-size: 100%;
  padding: 5px;
  padding-bottom: 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
  display: block;
}
.heading-online {
  /*display: none;*/
  padding: 0 5px;
  font-size: 12px;
  color: #93918f;
}
.heading-compose {
  padding: 0;
}

.heading-compose i {
  text-align: center;
  padding: 5px;
  color: #93918f;
  cursor: pointer;
}

.heading-dot {
  padding: 0;
  margin-left: 10px;
}

.heading-dot i {
  text-align: right;
  padding: 5px;
  color: #93918f;
  cursor: pointer;
}

.searchBox {
  padding: 0 !important;
  margin: 0 !important;
  height: 60px;
  width: 100%;
}

.searchBox-inner {
  height: 100%;
  width: 100%;
  padding: 10px !important;
  background-color: #fbfbfb;
}

/*#searchBox-inner input {
  box-shadow: none;
}*/

.searchBox-inner input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.sideBar {
  padding: 0 !important;
  margin: 0 !important;
  background-color: #fff;
  overflow-y: auto;
  border: 1px solid #f7f7f7;
  height: calc(100% - 120px);
}

.sideBar-body {
  position: relative;
  padding: 10px !important;
  border-bottom: 1px solid #f7f7f7;
  height: 72px;
  margin: 0 !important;
  cursor: pointer;
}

.sideBar-body:hover {
  background-color: #f2f2f2;
}

.sideBar-avatar {
  text-align: center;
  padding: 0 !important;
}

.avatar-icon img {
  border-radius: 50%;
  height: 49px;
  width: 49px;
}

.sideBar-main {
  padding: 0 !important;
}

.sideBar-main .row {
  padding: 0 !important;
  margin: 0 !important;
}

.sideBar-name {
  padding: 10px !important;
}

.name-meta {
  font-size: 100%;
  padding: 1% !important;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
}

.sideBar-time {
  padding: 10px !important;
}

.time-meta {
  text-align: right;
  font-size: 12px;
  padding: 1% !important;
  color: rgba(0, 0, 0, 0.4);
  vertical-align: baseline;
}

/*New Message*/

.newMessage {
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
  position: relative;
  left: -100%;
}
.newMessage-heading {
  padding: 10px 16px 10px 15px !important;
  margin: 0 !important;
  height: 100px;
  width: 100%;
  background-color: #00bfa5;
  z-index: 1001;
}

.newMessage-main {
  padding: 10px 16px 0 15px !important;
  margin: 0 !important;
  height: 60px;
  margin-top: 30px !important;
  width: 100%;
  z-index: 1001;
  color: #fff;
}

.newMessage-title {
  font-size: 18px;
  font-weight: 700;
  padding: 10px 5px !important;
}
.newMessage-back {
  text-align: center;
  vertical-align: baseline;
  padding: 12px 5px !important;
  display: block;
  cursor: pointer;
}
.newMessage-back i {
  margin: auto !important;
}

.composeBox {
  padding: 0 !important;
  margin: 0 !important;
  height: 60px;
  width: 100%;
}

.composeBox-inner {
  height: 100%;
  width: 100%;
  padding: 10px !important;
  background-color: #fbfbfb;
}

.composeBox-inner input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.compose-sideBar {
  padding: 0 !important;
  margin: 0 !important;
  background-color: #fff;
  overflow-y: auto;
  border: 1px solid #f7f7f7;
  height: calc(100% - 160px);
}

/*Conversation*/

.conversation {
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
  /*width: 100%;*/
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  /*overflow-y: auto;*/
}

.message {
  padding: 0 !important;
  margin: 0 !important;
  /*background: url("w.jpg") no-repeat fixed center;*/
  background-size: cover;
  overflow-y: auto;
  border: 1px solid #f7f7f7;
  height: calc(100% - 120px);
}
.message-previous {
  margin: 0 !important;
  padding: 0 !important;
  height: auto;
  width: 100%;
}
.previous {
  font-size: 15px;
  text-align: center;
  padding: 10px !important;
  cursor: pointer;
}

.previous a {
  text-decoration: none;
  font-weight: 700;
}

.message-body {
  margin: 0 !important;
  padding: 0 !important;
  width: auto;
  height: auto;
}

.message-main-receiver {
  /*padding: 10px 20px;*/
  max-width: 60%;
}

.message-main-sender {
  padding: 3px 20px !important;
  margin-left: 40% !important;
  max-width: 60%;
}

.message-text {
  margin: 0 !important;
  padding: 5px !important;
  word-break: break-word;
  font-weight: 200;
  font-size: 14px;
  padding-bottom: 0 !important;
}

.message-time {
  margin: 0 !important;
  margin-left: 50px !important;
  font-size: 12px;
  text-align: right;
  color: #9a9a9a;
}

.receiver {
  width: auto !important;
  padding: 4px 10px 7px !important;
  border-radius: 10px 10px 10px 0;
  background: #ffffff;
  font-size: 12px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  word-wrap: break-word;
  display: inline-block;
}

.sender {
  float: right;
  width: auto !important;
  background: #dcf8c6;
  border-radius: 10px 10px 0 10px;
  padding: 4px 10px 7px !important;
  font-size: 12px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  display: inline-block;
  word-wrap: break-word;
}

/*Reply*/

.reply {
  height: 60px;
  width: 100%;
  background-color: #f5f1ee;
  padding: 10px 5px 10px 5px !important;
  margin: 0 !important;
  z-index: 1000;
}

.reply-emojis {
  padding: 5px !important;
}

.reply-emojis i {
  text-align: center;
  padding: 5px 5px 5px 5px !important;
  color: #93918f;
  cursor: pointer;
}

.reply-recording {
  padding: 5px !important;
}

.reply-recording i {
  text-align: center;
  padding: 5px !important;
  color: #93918f;
  cursor: pointer;
}

.reply-send {
  padding: 5px !important;
}

.reply-send i {
  text-align: center;
  padding: 5px !important;
  color: #93918f;
  cursor: pointer;
}

.reply-main {
  padding: 2px 5px !important;
}

.reply-main textarea {
  width: 100%;
  resize: none;
  overflow: hidden;
  padding: 5px !important;
  outline: none;
  border: none;
  text-indent: 5px;
  box-shadow: none;
  height: 100%;
  font-size: 16px;
}

.reply-main textarea:focus {
  outline: none;
  border: none;
  text-indent: 5px;
  box-shadow: none;
}

@media screen and (max-width: 700px) {
  .app {
    top: 0;
    height: 100%;
  }
  .heading {
    height: 70px;
    background-color: #009688;
  }
  .fa-2x {
    font-size: 2.3em !important;
  }
  .heading-avatar {
    padding: 0 !important;
  }
  .heading-avatar-icon img {
    height: 50px;
    width: 50px;
  }
  .heading-compose {
    padding: 5px !important;
  }
  .heading-compose i {
    color: #fff;
    cursor: pointer;
  }
  .heading-dot {
    padding: 5px !important;
    margin-left: 10px !important;
  }
  .heading-dot i {
    color: #fff;
    cursor: pointer;
  }
  .sideBar {
    height: calc(100% - 130px);
  }
  .sideBar-body {
    height: 80px;
  }
  .sideBar-avatar {
    text-align: left;
    padding: 0 8px !important;
  }
  .avatar-icon img {
    height: 55px;
    width: 55px;
  }
  .sideBar-main {
    padding: 0 !important;
  }
  .sideBar-main .row {
    padding: 0 !important;
    margin: 0 !important;
  }
  .sideBar-name {
    padding: 10px 5px !important;
  }
  .name-meta {
    font-size: 16px;
    padding: 5% !important;
  }
  .sideBar-time {
    padding: 10px !important;
  }
  .time-meta {
    text-align: right;
    font-size: 14px;
    padding: 4% !important;
    color: rgba(0, 0, 0, 0.4);
    vertical-align: baseline;
  }
  /*Conversation*/
  .conversation {
    padding: 0 !important;
    margin: 0 !important;
    height: 100%;
    /*width: 100%;*/
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    /*overflow-y: auto;*/
  }
  .message {
    height: calc(100% - 140px);
  }
  .reply {
    height: 70px;
  }
  .reply-emojis {
    padding: 5px 0 !important;
  }
  .reply-emojis i {
    padding: 5px 2px !important;
    font-size: 1.8em !important;
  }
  .reply-main {
    padding: 2px 8px !important;
  }
  .reply-main textarea {
    padding: 8px !important;
    font-size: 18px;
  }
  .reply-recording {
    padding: 5px 0 !important;
  }
  .reply-recording i {
    padding: 5px 0 !important;
    font-size: 1.8em !important;
  }
  .reply-send {
    padding: 5px 0 !important;
  }
  .reply-send i {
    padding: 5px 2px 5px 0 !important;
    font-size: 1.8em !important;
  }
}
.highlight {
  background: gainsboro;
}
.newChat {
  background: red;
}
.payment-confirmed-i {
  font-size: 24px;
  color: #f44336;
  /* margin-top: 12px; */
  /*border: 1px solid #F44336;*/
  border-radius: 50px;
  padding: 12px;
}
.bg-red {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue